import { Button, type ButtonProps } from 'antd';
import { type LinkProps } from 'react-router-dom';
import { type LocationTo, useHistory } from '../../core/router/TypedRoute.tsx';

export interface LinkButtonProps extends Omit<ButtonProps, 'onClick'> {
  to: LocationTo;
  /**
   * @deprecated le props di linkProps non vengono più utilizzate
   */
  linkProps?: Omit<LinkProps, 'to'>;
}

/**
 * Button con funzionalità del Link di react-router-dom
 */
export function LinkButton(props: LinkButtonProps) {
  const { to, linkProps, ...buttonProps } = props;
  const history = useHistory();

  const handleClick = () => {
    history.push(to);
  };

  return <Button role="link" {...buttonProps} onClick={handleClick} />;
}
